module.exports = __webpack_public_path__ + "img/plashka-mobile.437ef65a.jpg";